import { render, staticRenderFns } from "./updatepaypwd.vue?vue&type=template&id=997afea8"
import script from "./updatepaypwd.vue?vue&type=script&lang=ts"
export * from "./updatepaypwd.vue?vue&type=script&lang=ts"
import style0 from "./updatepaypwd.vue?vue&type=style&index=0&id=997afea8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports